import React, { useState } from 'react';

const AddQuotationModal = ({ open, onClose, onSubmit }) => {
  const [form, setForm] = useState({ client: '', amount: '', validUntil: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(form);
    setForm({ client: '', amount: '', validUntil: '' });
  };

  return (
    <div className={`modal-overlay ${open ? 'active' : ''}`} onClick={onClose} data-testid="add-quotation-modal">
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-icon primary">+</div>
        <div className="modal-title">Buat Quotation Baru</div>
        <div className="modal-sub" style={{ marginBottom: '20px' }}>Buat penawaran harga untuk klien.</div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nama Client / Perusahaan</label>
            <input type="text" className="form-control" required placeholder="Contoh: Zenith Corp"
              value={form.client} onChange={e => setForm({ ...form, client: e.target.value })}
              data-testid="add-quotation-client" />
          </div>
          <div style={{ display: 'flex', gap: '16px' }}>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Total Penawaran</label>
              <input type="text" className="form-control" required placeholder="Rp 15.000.000"
                value={form.amount} onChange={e => setForm({ ...form, amount: e.target.value })}
                data-testid="add-quotation-amount" />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Berlaku Hingga</label>
              <input type="date" className="form-control" required value={form.validUntil}
                onChange={e => setForm({ ...form, validUntil: e.target.value })}
                data-testid="add-quotation-valid" />
            </div>
          </div>
          <div className="modal-actions">
            <button type="button" className="btn-modal btn-cancel" onClick={onClose} data-testid="add-quotation-cancel">Batal</button>
            <button type="submit" className="btn-modal btn-gold" data-testid="add-quotation-submit">Buat Penawaran</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddQuotationModal;
